import { Route, Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { LOGIN_URL } from "./constants/urls";
import SignIn from "./pages/SignIn";
import { onTokenExpiry } from "./services/authServices";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Orders from "./pages/Orders";
import ServicePersons from "./pages/ServicePersons";
import Farmers from "./pages/Farmers";
import Customers from "./pages/Customers";
import Users from "./pages/Users";

function App() {
  setInterval(() => {
    onTokenExpiry();
  }, 5 * 60 * 1000);

  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path={LOGIN_URL} element={<SignIn />} />
          <Route exact path="/" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/" element={<Dashboard />} />
          </Route>
          <Route exact path="/profile" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/profile" element={<Profile />} />
          </Route>
          <Route exact path="/customers" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/customers" element={<Customers />} />
          </Route>
          <Route exact path="/orders" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/orders" element={<Orders />} />
          </Route>
          <Route exact path="/farmers" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/farmers" element={<Farmers />} />
          </Route>
          <Route exact path="/executives" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/executives" element={<ServicePersons />} />
          </Route>
          <Route exact path="/users" element={<ProtectedRoute />}>
            {/* <Route exact path="/dashboard" element={<Dashboard />} /> */}
            <Route exact path="/users" element={<Users />} />
          </Route>
        </Routes>
      </>
    </BrowserRouter>
  );
}

export default App;
